import axios from '@/libs/api.request'
import { genURLParams } from '@/libs/urlparamhelper'

export const addObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/add' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const getAll = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/all' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const searchByName = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/searchbyname/' + params.name + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getPage = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const getDetail = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/' + params.id + '' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const modifyObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/modify' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const deleteObj = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/' + params.id + '' + genURLParams(urlParams),
    method: 'DELETE',
    credentials: 'include',
    data: params
  })
}

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

export const uploadPositioningdevicefittingsFile = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/uploadpositioningdevicefittingsfile' + genURLParams(urlParams),
    method: 'POST',
    credentials: 'include',
    data: params
  })
}

export const bindPositioningdeviceInfo = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/bindpositioningdeviceinfo/' + params.id + '/' + params.positioningdeviceinfoid + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const unBindPositioningdeviceInfo = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/unbindpositioningdeviceinfo/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getMyPositioningdeviceinfoUnBindPositioningdeviceInfo = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/getmypositioningdevicefittingunbindpositioningdeviceinfo' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changeInstaller = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/changeinstaller/' + params.id + '/' + params.installerId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchChangeInstaller = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/batchchangeinstaller/' + params.ids + '/' + params.installerId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const changeGroup = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/changegroup/' + params.id + '/' + params.userGroupId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchChangeGroup = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/batchchangegroup/' + params.ids + '/' + params.userGroupId + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const getMyPositioningdevicefitting = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/getmypositioningdevicefitting' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const modifyFactoryGuaranteePeriod = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/modifyfactoryguaranteeperiod/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchModifyFactoryGuaranteePeriod = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/batchmodifyfactoryguaranteeperiod/' + params.ids + '/' + params.factoryGuaranteePeriod + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const modifyClientGuaranteePeriod = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/modifyclientguaranteeperiod/' + params.id + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}

export const batchModifyClientGuaranteePeriod = (params, urlParams) => {
  return axios.request({
    url: '/im/positioningdevicefitting/batchmodifyclientguaranteeperiod/' + params.ids + '/' + params.clientGuaranteePeriod + '' + genURLParams(urlParams),
    method: 'PUT',
    credentials: 'include',
    data: params
  })
}
